import { oz } from '@weft/utils';
import type { ZapiAction, ZapiParam } from '@weft/zapi-types';
import { HUBSPOT_AUTH_CALLBACK_PATH } from './hubspot-auth-callback-path';

export const HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER = {
  name: 'code',
  location: 'query',
  schema: oz.string(),
} as const as ZapiParam;

export const HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER = {
  name: 'state',
  location: 'query',
  schema: oz.string(),
} as const as ZapiParam;

export const HUBSPOT_AUTH_CALLBACK_ACTION = {
  method: 'get',
  codeGenerationSettings: {
    actionText: 'hubspot-auth-callback',
  },
  queryParams: {
    [HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER.name]: HUBSPOT_AUTH_CALLBACK_CODE_QUERY_PARAMETER,
    [HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER.name]: HUBSPOT_AUTH_CALLBACK_STATE_QUERY_PARAMETER,
  },
  path: HUBSPOT_AUTH_CALLBACK_PATH,
} satisfies ZapiAction;

export type HubspotAuthCallbackAction = typeof HUBSPOT_AUTH_CALLBACK_ACTION;